import { LINKEDIN_COMPANY_URL } from '../../../config/socialLinks';

export function buildOrganizationSchema({ siteUrl, siteName }) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: siteName,
    alternateName: ['Leagora.io', 'Leagora Video', 'Leagora WebRTC'],
    url: siteUrl,
    logo: {
      '@type': 'ImageObject',
      url: `${siteUrl}/logo.png`,
      width: '250',
      height: '60',
    },
    description:
      'Leagora conçoit et déploie des infrastructures vidéo métier WebRTC pour les entreprises : assistance client, rendez-vous, live, API vidéo, hébergement France et intégration sur mesure.',
    address: {
      '@type': 'PostalAddress',
      addressCountry: 'FR',
      addressLocality: 'Paris',
      addressRegion: 'Île-de-France',
    },
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'Customer Service',
      email: 'contact@leagora.io',
      availableLanguage: ['French', 'English'],
      areaServed: ['FR', 'EU', 'Worldwide'],
    },
    areaServed: [
      { '@type': 'Country', name: 'France' },
      { '@type': 'AdministrativeArea', name: 'European Union' },
    ],
    sameAs: [LINKEDIN_COMPANY_URL],
  };
}
